import { AuthTo } from '@common/Auth'
import style from '@common/ModalIf/style.module.less'
import { SHOP_PRODUCTS_PATH } from '@constant'
import { HeaderView } from '@merchant-backend/common-components'
import {
  getSessionMerchantInfo,
  isSiDaProperty,
  isUltimate
} from '@merchant-backend/util'
import { isHotelMerchant } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import QRCode from 'qrcode.react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import Store from './store'
import Style from './style.module.less'

const THEME_DEFAULT = {
  id: 0,
  title: '默认',
  img: '//qnm.hunliji.com/o_1bgq4kankl6t2vc1e4g14191tov10.png'
}

const THEME_WHITE = {
  id: 1,
  title: '典雅白',
  img: '//qnm.hunliji.com/o_1bgq4k2mdlfa7ov1egf18ok1cogb.png'
}

const THEME_BLACK = {
  id: 2,
  title: '尊贵黑',
  img: '//qnm.hunliji.com/o_1bgq4k2me1d5isne1t0p131ejknc.png'
}

const THEME_GREEN = {
  id: 3,
  title: '清新绿',
  img: '//qnm.hunliji.com/o_1bgq4k2me1om51lnbk5514um1mhpd.png'
}

const THEME_BLUE = {
  id: 4,
  title: '雅典蓝',
  img: '//qnm.hunliji.com/o_1bgq4k2me1ciadg8154eaop1ga5e.png'
}

const THEME_PINK = {
  id: 5,
  title: '樱花粉',
  img: '//qnm.hunliji.com/o_1bgq54cq0tjav6v7rs17tovqg15.png'
}

@AuthTo({
  isAuthed: isUltimate,
  link: '/localMerchant/themeChose/intro'
})
@observer
export default class extends Component {
  componentDidMount() {
    Store.decorationFn()
  }

  getThemeListByProperty = () => {
    if (isSiDaProperty() || isHotelMerchant()) {
      return [THEME_DEFAULT, THEME_WHITE, THEME_BLACK]
    }

    return [
      THEME_DEFAULT,
      THEME_WHITE,
      THEME_BLACK,
      THEME_GREEN,
      THEME_BLUE,
      THEME_PINK
    ]
  }

  render() {
    let {
      qrCote,
      theme,
      modalIf: { type, isShow, btn1, btn2, content }
    } = Store
    let { id: merchantId } = getSessionMerchantInfo()
    let location = window.location.host

    return (
      <HeaderView title="主题模板">
        <div className={Style.themeBox}>
          <div className={Style.content}>
            {this.getThemeListByProperty().map(({ id, title, img }) => {
              let path = ''
              if (location == 'test.hunliji.com') {
                path =
                  '//mtest.hunliji.com/p/wedding/Public/wap/m/merchant.html?id=' +
                  merchantId +
                  '&'
              } else if (location == 'www7.hunliji.com') {
                path = '//m7.hunliji.com/merchant/detail_' + merchantId + '?'
              } else {
                path =
                  'https://m.hunliji.com/merchant/detail_' + merchantId + '?'
              }
              path += merchantId
              path += 'is_ultimate=1&preview=1&theme=' + id
              return (
                <dl key={id}>
                  <dt>{title}</dt>
                  <dd
                    onMouseOut={Store.hideQrCote(id)}
                    onMouseOver={Store.showQrCote(id)}
                    className={Style.posBox}
                  >
                    <img className={Style.pos} src={img} alt="" />)
                    {qrCote[id] ? (
                      <p className={Style.pos}>
                        <span>
                          <i>
                            <QRCode size={100} value={path} />
                          </i>
                          <em>扫码预览</em>
                        </span>
                      </p>
                    ) : (
                      ''
                    )}
                  </dd>
                  <dd>
                    {theme == id ? (
                      <Button>使用中</Button>
                    ) : (
                      <Button type="primary" onClick={Store.choseThemeFn(id)}>
                        选择
                      </Button>
                    )}
                  </dd>
                </dl>
              )
            })}
          </div>

          {isShow ? (
            <div className={style.tipBox} style={{ zIndex: 999 }}>
              <div className={style.tip2}>
                <div className={style.cont}>{content}</div>
                <div className={style.btnBox}>
                  {type == 1 && (
                    <button onClick={Store.onCancel}>{btn1}</button>
                  )}
                  {type == 2 && (
                    <span>
                      <button onClick={Store.onCancel}>{btn1}</button>
                      <button>
                        <Link to={SHOP_PRODUCTS_PATH}>{btn2}</Link>
                      </button>
                    </span>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </HeaderView>
    )
  }
}
